import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    IGeographicMapData,
    ILoanTypePurposeData,
    IMapParameters,
} from '../interfaces/geographic-map-data';

@Injectable({
    providedIn: 'root',
})
export class GeographicMapService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private componentName = 'GeographicMap';
    private _url = (this.serverUrl + '/api/v{version}/{componentName}')
        .replace('{version}', this.version)
        .replace('{componentName}', this.componentName);
    constructor(private http: HttpClient) {}

    public getStateMapData(parameters: IMapParameters): Observable<IGeographicMapData[]> {
        return this.http.post<IGeographicMapData[]>(this._url + '/GetUSMapData/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    public getLoanTypePurposeData(parameters: IMapParameters): Observable<ILoanTypePurposeData[]> {
        return this.http.post<ILoanTypePurposeData[]>(
            this._url + '/GetLoanTypePurposeData/',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    public getAvailableHMDAYearsUpTo5(): Observable<number[]> {
        return this.http.get<number[]>(this._url + '/GetAvailableYearsUpTo5/');
    }
}
